import { Phone, Mail, ArrowRight } from "lucide-react";
import { Button } from "../ui/button";
import { SITE } from "../../lib/site";

export const Contact = () => {
  return (
    <section
      id="contact"
      data-testid="contact-section"
      className="py-24 md:py-32 bg-brand-eucalyptus relative overflow-hidden"
    >
      <div className="absolute inset-0 grain pointer-events-none" />
      <div className="relative max-w-7xl mx-auto px-6 lg:px-8 grid lg:grid-cols-12 gap-12 items-center">
        <div className="lg:col-span-7 text-brand-cream">
          <div className="label-eyebrow text-brand-cream/70 mb-5">Get started</div>
          <h2 className="font-display text-4xl sm:text-5xl lg:text-6xl tracking-tight font-medium leading-[1.05]">
            Empower your future. Start with a conversation.
          </h2>
          <p className="mt-6 text-base md:text-lg text-brand-cream/80 leading-relaxed max-w-xl">
            A no-pressure 15-minute call is all it takes. We&apos;ll listen
            first, then map out your options across 40+ Australian lenders.
            Servicing all of Australia.
          </p>
        </div>

        <div className="lg:col-span-5">
          <div className="rounded-3xl bg-brand-cream/5 border border-brand-cream/15 p-8 backdrop-blur-sm">
            <div className="text-xs uppercase tracking-widest text-brand-cream/60">
              Talk to a broker
            </div>
            <a
              href={SITE.phoneTel}
              data-testid="contact-phone-link"
              className="mt-3 block font-display text-4xl sm:text-5xl text-brand-cream hover:text-brand-terracotta transition-colors"
            >
              {SITE.phone}
            </a>
            <a
              href={SITE.emailHref}
              data-testid="contact-email-link"
              className="mt-4 inline-flex items-center gap-2 text-base text-brand-cream/85 hover:text-brand-terracotta transition-colors break-all"
            >
              <Mail className="h-4 w-4 shrink-0" strokeWidth={1.8} />
              {SITE.email}
            </a>

            <div className="mt-6 grid sm:grid-cols-2 gap-3 text-sm text-brand-cream/70">
              <div>
                <div className="text-xs uppercase tracking-widest text-brand-cream/50">
                  Hours
                </div>
                <div className="mt-1.5">Mon – Fri · 9am – 6pm AEST</div>
              </div>
              <div>
                <div className="text-xs uppercase tracking-widest text-brand-cream/50">
                  Coverage
                </div>
                <div className="mt-1.5">{SITE.region}</div>
              </div>
            </div>

            <a
              href={SITE.phoneTel}
              data-testid="contact-call-button"
              className="block mt-8"
            >
              <Button className="w-full h-14 rounded-full bg-brand-cream text-brand-eucalyptus hover:bg-brand-terracotta hover:text-brand-cream text-base transition-all duration-300 hover:-translate-y-0.5 hover:shadow-lg">
                <Phone className="h-5 w-5 mr-2" strokeWidth={1.8} />
                Call {SITE.phone}
                <ArrowRight className="h-5 w-5 ml-2" strokeWidth={1.8} />
              </Button>
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};
